export enum MonitoringFileTypesEnum {
    'TRANSLATION' = 'TRANSLATION'
}
